import React, { createContext, useEffect, useState } from "react";

const AppContext = createContext();
const AppProvider = ({ auth: authInProps, iam: iamInProps, iamChecked: iamCheckedInProps, cfg: cfgInProps, children }) => {
    const [auth, setAuth] = useState(authInProps);
    const [iam, setIam] = useState(iamInProps);
    const [iamChecked, setIamChecked] = useState(iamCheckedInProps ?? false);
    const [cfg, setCfg] = useState(cfgInProps);
    useEffect(() => {
        setAuth(authInProps);
    }, [authInProps]);
    useEffect(() => {
        setIam(iamInProps);
    }, [iamInProps]);
    useEffect(() => {
        setIamChecked(iamCheckedInProps ?? false);
    }, [iamCheckedInProps]);
    useEffect(() => {
        setCfg(cfgInProps);
    }, [cfgInProps]);
    const saveAuth = (auth) => {
        setAuth(auth);
    };
    const saveIam = (iam) => {
        setIam(iam);
    };
    const saveCfg = (cfg) => {
        setCfg(cfg);
    };

    return <AppContext.Provider value={{ auth, saveAuth, iam, saveIam, iamChecked, cfg, saveCfg }}>{children}</AppContext.Provider>;
};

export { AppContext, AppProvider };
